import React, { useState, useEffect } from 'react'
import { Link, HeaderNavItem } from 'newComponents'
import classNames from 'classnames'

import downChevron from '../../../images/navbar/arrow_toggle.svg'

import './style.scss'

export default (props) => {
  const { item } = props
  // state
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [mobileDropdownHidden, setMobileDropdownHidden] = useState(true)
  const [reduceOpacity, setReduceOpacity] = useState(false)

  useEffect(() => () => document.body.classList.remove('subnav-open'), [])

  // functions
  const handleDropdownClick = () => {
    setDropdownOpen(!dropdownOpen)
  }

  const handleMobileDropdownClick = () => {
    setMobileDropdownHidden(!mobileDropdownHidden)
  }

  const handleMouseEnter = () => {
    document.body.classList.add('subnav-open')
  }

  const handleMouseLeave = () => {
    document.body.classList.remove('subnav-open')
  }

  const toggleOpacity = () => {
    setReduceOpacity(!reduceOpacity)
  }

  const toggleMobileDropdown = classNames('header-nav-dropdown', {
    'header-nav-mobile-dropdown-hidden': mobileDropdownHidden
  })

  const mobileCta = classNames('header-nav-mobile-cta-arrow', {
    'header-nav-mobile-cta-rotate': !mobileDropdownHidden
  })

  return (
    <>
      {/* HAS DROPDOWN LINKS */}
      {item.dropdown ? (
        <div
          className="header-nav-item header-nav-has-dropdown"
          aria-expanded={dropdownOpen}
          aria-haspopup="true"
          role="menu"
          tabIndex="0"
          onClick={handleDropdownClick}
          onKeyDown={handleDropdownClick}
          onFocus={handleDropdownClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button type="button" className="header-nav-link" onClick={handleMobileDropdownClick}>
            <span className="header-nav-mobile-cta">
              {/* NAV ITEM CLICKABLE */}
              {item.url ? (
                <>
                  <Link to={item.url} className="" tabIndex="0">
                    <span>{item.name}</span>
                  </Link>
                  <span className="header-nav-mobile-nonclickable">{item.name}</span>
                </>
              ) : (
                <span>{item.name}</span>
              )}
              <span className={mobileCta}>
                <img src={downChevron} alt="open menu" />
              </span>
            </span>
          </button>
          <div className={toggleMobileDropdown}>
            <div className="header-nav-items">
              <div className="header-nav-dropdown-submenu-section">
                {item.dropdown.map((list, i) => (
                  <div className="header-nav-column" key={list.name}>
                    <h4
                      className={classNames('header-nav-dropdown-submenu-title', {
                        'header-nav-bottom-bar-full': list.name === 'Features' || 'Success Stories'
                      })}
                    >
                      {list.name}
                    </h4>
                    <div
                      className={classNames('header-nav-dropdown-submenu', {
                        'header-nav-customer-dropdown': list.name === 'Success Stories'
                      })}
                    >
                      {list.children.map((link) => (
                        <HeaderNavItem
                          link={link}
                          reduceOpacity={reduceOpacity}
                          toggleOpacity={toggleOpacity}
                          key={link.url}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        // DOESN'T HAVE DROP DOWN LINKS
        <Link className="header-nav-item header-nav-item-link-only" to={item.url} tabIndex="0">
          <span className="header-nav-link-name">{item.name}</span>
        </Link>
      )}
    </>
  )
}
